<template>
<div >
	
<b-navbar 
	v-if="show_menu == 1"
	toggleable="lg" type="light" variant="white" class="border-bottom p-0 mb-3 gold"
>
	<div class="row text-center p-0 m-0">
		<div class="col-2 d-block d-sm-none">
			<b-navbar-toggle target="nav-collapse" class="p-1 m-1"></b-navbar-toggle>
		</div>
		<div class="col-3 col-sm-4 p-1 m-1 ml-3 mt-2 mr-3">
			<a href="/">
				<img :src="this.$store.state.layout.logo" alt="iAMc" width="auto" height="22" class="mr-4" />
			</a>
		</div>
		<div class="col-4 col-sm-5">
			<category-dropdown title="All Categories" />
		</div>
		
		
	</div>


	
	
	
	<b-collapse id="nav-collapse" is-nav class="">
		<b-navbar-nav v-for="item in menu.items" :key="'a-' + item.link">
			
			<b-nav-item-dropdown v-if="item.is_dropdown" right>
			
				<template v-slot:button-content>
					<span v-if="item.icon != ''"><i :class="item.icon" /></span> <span v-html="item.label"></span>
				</template>
				
				<b-dropdown-item v-for="dd in item.items" :key="'dd-' + dd.link">
					<router-link :to="dd.link">
						<span v-if="dd.icon != ''"><i :class="dd.icon" /></span> <span v-html="dd.label"></span>
					</router-link>
				</b-dropdown-item>
				
			</b-nav-item-dropdown>
		
			<b-nav-item v-else>
				<router-link :to="item.link" target="item.target">
					<span v-if="item.icon != ''"><i :class="item.icon" /></span> <span v-html="item.label"></span>
				</router-link>
			</b-nav-item>
  
		</b-navbar-nav>
		
		<!-- Right aligned nav items -->
		<b-navbar-nav class="ml-auto">
			
			<div class="row" v-if="show_search == 1 && this.$store.state.profile.status == 1">
				<b-form-input
					id="search_term"
					v-model="search_term"
					type="text"
					required
					placeholder="Search"
					maxlength="150"
					class="col-8 ml-2 mt-2 "
				></b-form-input>
				<b-button class="col-2 m-1 mt-2 p-1 gold" type="button" @click="setSearchTerm()">
					<i class="fas fa-search"></i>
				</b-button>
			</div>

			
			
			<div v-if="this.$store.state.profile.status == 0">
				<b-nav-item><router-link to="/login">Login <i class="fas fa-sign-in-alt"></i></router-link></b-nav-item>
			</div>

			<div v-else>
				
				<b-nav-item-dropdown right class="">
					<!-- Using 'button-content' slot -->
					<template v-slot:button-content>
						<i class="ml-2 far fa-user-circle"></i> <span v-text="profile_name"></span>
					</template>
					
					<router-link to="/app" class="dropdown-item">My Dashboard</router-link>
					<router-link to="/profile" class="dropdown-item">Profile</router-link>
					<b-nav-item class="dropdown-item" @click="logOut()">Sign Out</b-nav-item>
					
				</b-nav-item-dropdown>
			</div>
		</b-navbar-nav>	
		
	</b-collapse>
</b-navbar>

</div>
</template>

<script>
import CategoryDropdown from '../components/CategoryDropdown.vue';
import * as Cookie from '@/assets/js/cookie.js';

export default {
	name: 'TopNavi',
	components:{ 
		CategoryDropdown,
	},
	props: {
		profile_name: {
			type: String,
		}
	},
	data() {
		return {
			session_id: this.$store.state.session_id,
			search_term: this.$store.state.search_term,
		}
	},
	computed: {
		menu(){
			var menu = {
				items: this.$store.getters.menuGetItems,
			};
			return menu;
		},
		show_menu(){
			var val = 1;
			if(this.$route.name === 'login'){
				val = 0;
			}
			return val;
		},
		show_search(){
			var val = 1;
			if(this.$route.name === 'search_results'){
				val = 0;
			}
			return val;
		},
	},
	methods: {
		logOut(){
			var vars = {
				profile: {
					status: 0
				}
			};
			this.$store.commit("profileSet", vars );
			this.$store.commit("menuSet", { menu: { items: null } } );
			Cookie.deleteCookie("user_session", process.env.VUE_APP_DOMAIN);
			this.$router.push('/login');
		},

		setSearchTerm(){
			this.$store.commit("searchTermSet", { search_term: this.search_term} );
			if(this.$route.name != 'search_results'){
				this.$router.push('/search_results');
			}
			
		}
	},
	mounted() {
	},
	watch: {
		search_term: function(val){
			console.log(val);
		},
		'$route' (val){
			if(val.name === 'categories'){
				this.$store.commit("categorySlugSet", val.params.slug );
				this.$store.commit("categoryActiveSet", val.params.slug );
			}
		},
	}
}  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
